import { Component, Input, OnChanges } from "@angular/core";
import { OrderStatus } from "src/services/order/order-status.type";
import { ApiOrderStatus } from "../../../../../services/order/order-api.service";
import { camelCaseToDisplayString } from "../../../../../services/utils/string.utils";

@Component({
  selector: "rc-order-status-badge",
  templateUrl: "./order-status-badge.component.html",
  styleUrls: ["./order-status-badge.component.scss"],
  standalone: false,
})
export class OrderStatusBadgeComponent implements OnChanges {
  @Input() public orderStatus: OrderStatus | ApiOrderStatus;

  public color: string;
  public displayStatus: string;

  constructor() {}

  public ngOnChanges() {
    this.displayStatus = camelCaseToDisplayString(this.orderStatus);
    switch (this.orderStatus) {
      case "new":
        this.color = "dodger";
        break;
      case "inProgress":
        this.color = "purple";
        break;
      case "pending":
        this.color = "orange";
        break;
      case "completed":
        this.color = "success";
        break;
      case "cancelled":
        this.color = "gray";
        break;
      default:
        this.color = "warning";
    }
  }
}
